export const faceConfig = {
    "FACE_0": {
        "isBorderFilled": true,
        "frameColor": "#660000",
        "hingeColor": '#333',
        "handColor": "#333"
    },
    "FACE_1": {
        "isFrameGradient": true,
        "frameGradientColorList": ['#333', '#FFFFFF', '#333'],
        "hingeColor": '#333',
        "handColor": "#333"
    },
    "FACE_2": {
        "isFrameGradient": true,
        "frameGradientColorList": ['#660000', '#ff0000', '#ffcccc'],
        "hingeColor": '#660000'
    },
    "FACE_3": {
        "isFrameGradient": true,
        "frameGradientColorList": ['#4d3d00', '#ffcc00', '#ffe680', '#fffae6', '#ffe680', '#ffcc00', '#4d3d00'],
        "hingeColor": '#cca300',
        "numberColors": {
            "1": "#cca300",
            "2": "#cca300",
            "3": "#cca300",
            "4": "#cca300",
            "5": "#cca300",
            "6": "#cca300",
            "7": "#cca300",
            "8": "#cca300",
            "9": "#cca300",
            "10": "#cca300",
            "11": "#cca300",
            "12": "#cca300"
        },
        "fillColor": '#333333',
        "handColor": "#cca300"
    },
    "FACE_4": {
        "isFrameGradient": true,
        "frameGradientColorList": ["#ff0000","#00ff00","#0000ff"],
        "hingeColor": "#660000",
        "numberColors": {
            "1": "#0059b3",
            "2": "#00cc7a",
            "3": "#4d94ff",
            "4": "#ff33bb",
            "5": "#ff9933",
            "6": "#2d2d86",
            "7": "#8600b3",
            "8": "#800000",
            "9": "#00e6e6",
            "10": "#ffff00",
            "11": "#0033cc",
            "12": "#ff0000"
        },
        "handColor": "#660000",
        "frameColor": "#660000"
    }
}


// WEBPACK FOOTER //
// ./src/faces/config.js